import { Row, Card, Col, Form } from "react-bootstrap";
import { http } from "Utils/http";
import { useEffect, useState } from "react";
import 'react-phone-input-2/lib/style.css'
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { useDispatch } from "react-redux"
import 'react-phone-input-2';
import { PageInfo } from "Components/PageInformation/PageInformation";
import { TextButton } from "Components/Button";
import {store} from 'Store';
import { openInNewTab } from "Utils/utilityFunctions";
import DynamicFormPopup from "Components/Popup/DynamicFormPopup";
import { ERROR_MESSAGES} from "Utils/constants";

function HelpCenter () {
    //const navigate = useNavigate();
    const dispatch = useDispatch();
    const [collabUrl, setCollabUrl] = useState(null);
    const [isTermsAgreed, setIsTermsAgreed] = useState(null);

    const [showTermsPopup, setShowTermsPopup] = useState(false);
    const [isViewOnly, setIsViewOnly] = useState(false);
    
    const openHelpCenter = (isViewOnly,isClicked) => {
        //console.log(isViewOnly);
        
        if(isViewOnly!=null && isViewOnly==true){
            // the user has agreed on the term of use. go to help center.
            //console.log('user agreed TOU, go to help center.');
            setIsViewOnly(isViewOnly);
            setShowTermsPopup(true);
        }
        else{
            //console.log(isTermsAgreed);
            if (isTermsAgreed != null && isTermsAgreed == 0 && showTermsPopup==false) {
                // the user has not agreed on the term of use. open popup.
                //console.log('not agreed TOU or popup open, psoppcCollaborationUrl: ' + collabUrl)
                setShowTermsPopup(true);

            } 
            else if (isTermsAgreed !=null && isTermsAgreed == 1) {
                if (collabUrl == null) {
                    // sso url should be initialized at the beginning, give one more try if we did not get sso url initialized.
                    //handleGetUrl();
                    handleGetAccess().then((res)=> {
                        //console.log(res);
                        if (res != null) {
                            setCollabUrl(res);
                            openInNewTab(res);
                        }
                    });
                }
                else{
                    //console.log(isClicked);
                    if(isClicked==true){
                        handleGetAccess().then((res)=> {
                            //console.log(res);
                            if (res != null) {
                                openInNewTab(res);
                            }
                        });
                    }
                    else{
                        openInNewTab(collabUrl);
                    }
                    
                    // only open help center when we have a valid url.
                    setShowTermsPopup(false);
                }
            }
        }
    }

    const handleGetAccess = async (e) => {
        var url = '/api/getcollaborationaccess';

        const loginState = store.getState().loginInfo;
        //console.log(loginState);
        const res = http.post(url, null,{
            timeout: 65000, // Set a timeout of 5 seconds,
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            //console.log(response);
            if(response != null ){
                var statusCode = response.status;
                if(statusCode != 1){
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true, 
                            title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                            msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length>0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                            showContactHelp: false 
                        },
                        redirect: {
                            redirect: false, 
                            redirectFirst: false,
                            path: "", 
                            data: {}
                        }
                    });
                }
                else {
                    if(response.data.agreedHelpCenterTerms != null){
                        //if(isTermsAgreed != response.data.agreedHelpCenterTerms){
                            setIsTermsAgreed(response.data.agreedHelpCenterTerms);
                        //}
                    }
                    setCollabUrl(response.data.helpCenterUrl);  
                    return response.data.helpCenterUrl;
                } 
            }
            else{
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: true 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
            }
            
        }).catch(function (error) {
            //console.log(error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                },
                error: error
            });
        });
        return res;
    };

    const handleAgree = async (e) => {
        var url = '/api/agreedCollaborationTou';

        const loginState = store.getState().loginInfo;
        //console.log(loginState);
        const res = http.post(url, null,{
            timeout: 65000, // Set a timeout of 5 seconds,
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            //console.log(response);
            if(response !=null ){
                var statusCode = response.status;
                if(statusCode != 1){
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true, 
                            title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                            msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length>0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                            showContactHelp: false 
                        },
                        redirect: {
                            redirect: false, 
                            redirectFirst: false,
                            path: "", 
                            data: {}
                        }
                    });
                }
                else {
                    setIsTermsAgreed(1);
                    setShowTermsPopup(false);
                }   
                
            }
            else{
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: true 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
            }
            
        }).catch(function (error) {
            //console.log(error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                },
                error: error
            });
        });
        return res;
    };

    /*const handleGetUrl = async (e) => {
        var url = '/retrieveCollaborationUrl';

        const loginState = store.getState().loginInfo;
        //console.log(loginState);
        const res = http.post(url, null,{
            timeout: 65000, // Set a timeout of 5 seconds,
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            //console.log(response);
            if(response !=null ){
                var statusCode = response.status;
                if(statusCode != 1){
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true, 
                            title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                            msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length>0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                            showContactHelp: false 
                        },
                        redirect: {
                            redirect: false, 
                            redirectFirst: false,
                            path: "", 
                            data: {}
                        }
                    });
                }
                else {
                    if(response.hasOwnProperty("data")){
                        setCollabUrl(response.data);
                    }
                }   
            }
            else{
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: true 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
            }
            
        }).catch(function (error) {
            //console.log(error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                },
                error: error
            });
        });
        return res;
    };*/

    useEffect(()=> {
        handleGetAccess();
    },[])

    useEffect(()=> {
        openHelpCenter(false, false);
    },[isTermsAgreed])

    const hideTermsPopup = () => {
        setShowTermsPopup(false);
        if(isViewOnly==true){
            setIsViewOnly(false);
        }
    }

    var popupButtons = [
        {
            text: "Agree",
            action: handleAgree,
            variant: "normal",
            //disabled: feedbackCharCount < 1 || isFeedbackLoading==true ? true: false
        },
        {
            text: "Close",
            action: hideTermsPopup,
            variant: "outline",
            //disabled: false
        }
    ]

    var popupButtonsView = [
        {
            text: "Close",
            action: hideTermsPopup,
            variant: "outline",
            //disabled: false
        }
    ]
        
    return (
        <Row >
                <DynamicFormPopup
                    showPopup = {showTermsPopup}
                    handleClose = {hideTermsPopup}
                    buttons = {isViewOnly == true && isTermsAgreed!=null && isTermsAgreed==1 ? popupButtonsView : popupButtons}
                    title = {"PSOPPC Help Center Term of Use"}
                    type= {"blank"}
                    variant={"blank"}
                >
                    <div className="ms-4 me-4 mt-2">
                        {/*<h2 tabindex="0" class="titlelabel" autofocus >PSOPPC Help Center</h2>*/}
                        <p >Welcome to the PSOPPC Help Center. It provides a collaboration space for PSOs to easily share information with one another, advancing knowledge and best practices for each PSO to use based on the feedback/experiences from their peers. To use the PSOPPC Help Center, you must review and agree to the PSOPPC's <b>Terms of Use</b>.</p>
                        
                        <PageInfo message={"Do not share any Protected Health Information (PHI), Personally Identifiable Information (PII), or Patient Safety Work Product (PSWP) with the PSOPPC Help Center."} type="info"></PageInfo>
                        <p className="mt-3">By clicking the button below, I acknowledge that I have read and agree to abide by the PSOPPC Terms of Use and the statements above.</p>

                        <p>In addition to the PSOPPC Terms of Use, PSOPPC Help Center users warrant to the accuracy and completeness of the information shared within the Help Center , agree to not market nor promote their services, and consume any and all information at their own risk. Furthermore, users agree to hold harmless AHRQ and the PSOPPC for any information that is incorrect or misleading. Content supporting prohibited partisan political activity is not permitted. AHRQ and the PSOPPC make no warranties, expressed or implied, regarding errors and omissions and assume no legal responsibility for loss or damage resulting from the use of PSOPPC Help Center  information and resources. PSOPPC Help Center functionality provided by the PSOPPC does not constitute legal advice and does not constitute or imply approval of any submitted documents, official guidance, or a final decision by AHRQ. AHRQ retains the right to remove content. Please see <a title="External Link to AHRQ's Comment Policy" tabindex="0" class="external-link" href="https://www.ahrq.gov/policy/social-media/comments/index.html" target="_blank">AHRQ's Comment Policy</a> for additional details.</p>
                   </div>
                </DynamicFormPopup>

                <Row >
                    <Col xl={11} lg={11} md={11} sm={12}>
                        <Card className="p-4" >
                            <Card.Body className="text-start">

                                <Row>
                                    <h1 id="mainContent" className="header1 text-start mb-3 blue bold">PSOPPC Help Center</h1>
                                    <p>Welcome to the PSOPPC Help Center. It provides a collaboration space for PSOs to easily share information with one another, advancing knowledge and best practices for each PSO to use based on the feedback/experiences from their peers. To use the PSOPPC Help Center, you must review and agree to the PSOPPC's <a href="#" onClick={()=>openHelpCenter(true)} >Terms of Use</a>.</p>
                                    <PageInfo message={"Do not share any Protected Health Information (PHI), Personally Identifiable Information (PII), or Patient Safety Work Product (PSWP) with the PSOPPC Help Center."} type="info"></PageInfo>
                                    
                                </Row>
                                <Row>
                                    <Form>
                                        <p className="mt-3">By clicking the button below, I acknowledge that I have read and agree to abide by the PSOPPC Terms of Use and the statements above.</p>
                                        
                                        <TextButton
                                            variant="normal"
                                            onClick={()=>openHelpCenter(false, true)}
                                            content={"Go to PSOPPC Help Center"}
                                            //ref={submitBtnRef}
                                            //disabled={(confirmSubmit.checkBoxes[0]).isChecked == true && isLoading!=true && isLoadingSubmit!=true ? false : true }
                                        >    
                                        </TextButton>
                                        <h2>How to use the PSOPPC Help Center</h2>
                                        <p>The PSOPPC Help Center users can:</p>
                                        <ul>
                                            <li>Submit and manage support requests</li>
                                            <li>Search articles, posts, and comments</li>
                                            <li>Discuss Featured Topics and various topics</li>
                                        </ul>
                                        <p>In addition to the PSOPPC Terms of Use, PSOPPC Help Center users warrant to the accuracy and completeness of the information shared within the Help Center , agree to not market nor promote their services, and consume any and all information at their own risk. Furthermore, users agree to hold harmless AHRQ and the PSOPPC for any information that is incorrect or misleading. Content supporting prohibited partisan political activity is not permitted. AHRQ and the PSOPPC make no warranties, expressed or implied, regarding errors and omissions and assume no legal responsibility for loss or damage resulting from the use of PSOPPC Help Center  information and resources. PSOPPC Help Center functionality provided by the PSOPPC does not constitute legal advice and does not constitute or imply approval of any submitted documents, official guidance, or a final decision by AHRQ. AHRQ retains the right to remove content. Please see <a title="External Link to AHRQ's Comment Policy" tabindex="0" class="external-link" href="https://www.ahrq.gov/policy/social-media/comments/index.html" target="_blank">AHRQ's Comment Policy</a> for additional details.</p>
                                    </Form>
                                    
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            
        </Row>
    );
}

export default HelpCenter;
